import { configureStore, UnknownAction } from '@reduxjs/toolkit'

import { talkJsSlice } from '../../../store/talkJsSlice'
import { userSlice, UserState } from '../../../store/userSlice'
import { mainReducer } from '../../main/redux/actions'
import { MainState } from '../../main/redux/store/get-initial-data'
import { PublicEmptyLegTableState, tableSlice } from './tableSlice'

export type RootState = Omit<MainState, 'talkJs' | 'user'> & {
    user: UserState
    talkJs: ReturnType<typeof talkJsSlice.reducer>
    publicEmptyLegsTable: PublicEmptyLegTableState
}

type StoreInitState = Partial<RootState>

const reducer = (state: RootState | undefined, action: UnknownAction): RootState => {
    const registrationState = mainReducer(state, action)

    return {
        ...registrationState,
        user: userSlice.reducer(state?.user ?? registrationState.user ?? undefined, action),
        talkJs: talkJsSlice.reducer(state?.talkJs ?? registrationState.talkJs, action),
        publicEmptyLegsTable: tableSlice.reducer(state?.publicEmptyLegsTable, action),
    }
}

export const getStore = (initState: StoreInitState) => {
    const preloadedState: RootState = {
        ...reducer(undefined, { type: '@@public-empty-legs/init' }),
        ...initState,
    }

    return configureStore({
        reducer,
        preloadedState,
    })
}

export type AppStore = ReturnType<typeof getStore>
export type AppDispatch = AppStore['dispatch']

export type ThunkApiConfig = {
    state: RootState
    dispatch: AppDispatch
    rejectValue: string
    extra: unknown
}
